import { RouteObject } from "../../helpers/tixxt-router";
import { lazy, Suspense } from "react";
import Loading from "../shared/Loading";

const RundschreibenPage = lazy(
  () => import("../../components/rundschreiben/RundschreibenPage"),
);

const ActivitystreamPage = lazy(
  () => import("../../components/activitystreams/ActivitystreamPage"),
);

const ActivityPage = lazy(() => import("./ActivityPage"));

const NotificationsPage = lazy(() => import("./NotificationsPage.tsx"));
const ActivityNewPage = lazy(() => import("./mobileApp/ActivityNewPage.tsx"));
const ActivityEditPage = lazy(() => import("./mobileApp/ActivityEditPage.tsx"));

const reactRoutes: RouteObject[] = [
  {
    path: "/rundschreiben",
    element: (
      <Suspense fallback={<Loading />}>
        <RundschreibenPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/activitystreams",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivitystreamPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/activitystreams/:streamSlug",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivitystreamPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/activitystreams/:streamSlug/:filter",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivitystreamPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/activitystreams/:streamSlug/activities/new",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityNewPage />
      </Suspense>
    ),
  },
  {
    path: "/activitystreams/:streamSlug",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivitystreamPage />
      </Suspense>
    ),
  },
  {
    path: "/activitystreams/:streamSlug/:filter",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivitystreamPage />
      </Suspense>
    ),
  },
  {
    path: "/activitystreams/:streamSlug/activities/new",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityNewPage />
      </Suspense>
    ),
  },
  {
    path: "/activities/:activityId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityEditPage />
      </Suspense>
    ),
  },
  {
    path: "/activities/:activityId/replies/:commentId",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityPage />
      </Suspense>
    ),
  },
  {
    path: "/activities/:activityId/answers/:commentId",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityPage />
      </Suspense>
    ),
  },
  {
    path: "/activities/:activityId",
    element: (
      <Suspense fallback={<Loading />}>
        <ActivityPage />
      </Suspense>
    ),
  },
  {
    path: "/notifications",
    element: (
      <Suspense fallback={<Loading />}>
        <NotificationsPage />
      </Suspense>
    ),
  },
];

export default reactRoutes;
